import type { ThemeConfig, ColorTheme } from './types';

export const themeConfigs: ThemeConfig[] = [
  { name: 'default', label: 'Default', previewColor: '#3b82f6' },
  { name: 'blue', label: 'Blue', previewColor: '#3b82f6' },
  { name: 'darkblue', label: 'Navy', previewColor: '#1e40af' },
  { name: 'ocean', label: 'Ocean Blue', previewColor: '#0284c7' },
  { name: 'slate', label: 'Slate', previewColor: '#111827' },
  { name: 'teal', label: 'Teal', previewColor: '#14b8a6' },
  { name: 'forest', label: 'Forest Green', previewColor: '#15803d' },
  { name: 'emerald', label: 'Emerald', previewColor: '#10b981' },
  { name: 'sunset', label: 'Sunset Orange', previewColor: '#ea580c' },
  { name: 'royal', label: 'Royal Purple', previewColor: '#7c3aed' },
  { name: 'purple', label: 'Purple', previewColor: '#8b5cf6' },
  { name: 'rose', label: 'Rose', previewColor: '#f43f5e' },
  { name: 'monochrome', label: 'Mono', previewColor: '#64748b' },
];

export const colorThemeNames: ColorTheme[] = [
  'default',
  'blue',
  'darkblue',
  'ocean',
  'slate',
  'teal',
  'forest',
  'emerald',
  'sunset',
  'royal',
  'purple',
  'rose',
  'monochrome',
];
